import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { ComposeViewState } from 'owa-mail-compose-store';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';

const infoBarAddHandler = (viewState: ComposeViewState) => (
    messageId: string,
    infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
) => {
    addInfoBarMessage(viewState, messageId, infoBarMessageViewStateCreator);
};

const infoBarRemoveHandler = (viewState: ComposeViewState) => (messageIds: string[]) => {
    removeInfoBarMessage(viewState, messageIds);
};

const infoBarGetIdsHandler = (viewState: ComposeViewState) => () => {
    return viewState.infoBarIds;
};

export { infoBarAddHandler, infoBarRemoveHandler, infoBarGetIdsHandler };
